import type { HelpFile } from '../../types/help'
import { SapSfEcInboundConfigEditDialogTestIds } from '../../../testids/SapSfEcInboundConfigEditDialogTestIds'

export const sapSfEcInboundConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/sap-sf-ec-connector',
  texts: {
    [SapSfEcInboundConfigEditDialogTestIds.btnCancelSapSfEcConfig]: null,
    [SapSfEcInboundConfigEditDialogTestIds.btnSaveSapSfEcConfig]: null,
    [SapSfEcInboundConfigEditDialogTestIds.selectSapSfEcAuthType]:
      'Authentication scheme. OAUTH2_CLIENT for direct SuccessFactors-issued client credentials; OAUTH2_SAML_BEARER (RFC 7522) when the tenant is fronted by IAS or another SAML IdP.',
    [SapSfEcInboundConfigEditDialogTestIds.selectSapSfEcDatetimeFormat]:
      'Timestamp encoding the SF EC tenant returns. ISO_8601 is the canonical format; EPOCH_MS is the legacy /OData(/Date(...))/ envelope still seen on older tenants.',
  },
}
